module.exports = __webpack_public_path__ + "site/img/email.5bb31568.svg";